import React from 'react';
import { Switch } from 'react-router';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import Footer from './Footer';

const Layout = props => {
    return (
      <div>
        <NavMenu />
            <Container className="container-margin">
                <Switch>
                    {props.children}
                </Switch>
            </Container>
        <Footer />
      </div>
    );
}

export default Layout;
